import { EMPTY_STRING } from '../../constants/common'

export const CHATROOM_SEND_PERMISSIONS_DISABLED = {
  canSendAiGeneratedMessage: false,
  canSendMessage: false,
  canSendTemplatedMessage: false,
}

export const CHATROOM_INITIAL_PAGES_MAX = 5

export const CHATROOM_REALTIME_FETCH_DEBOUNCE_MS = 200

export const CHATROOM_REALTIME_EVENT = {
  MessageCreated: 'message_created',
  MessageDeleted: 'message_deleted',
  MessageUpdated: 'message_updated',
}

export const CHATROOM_SCROLL_NEAR_BOTTOM_THRESHOLD_PX = 250

export const CHATROOM_LOAD_OLDER_OBSERVER_OPTIONS = {
  rootMargin: '120px 0px 0px 0px',
  threshold: 0,
}

export const QA_NAME_CHATROOM = 'chatroom'

export const QA_NAME_CHATROOM_INPUT_SEND = 'chatroomInputSend'

export const CHATROOM_INPUT_FIELD_NAME_MESSAGE = 'message'

export const CHATROOM_INPUT_FIELD_NAME_TEMPLATE = 'template'

export const CHATROOM_INPUT_FIELD_NAME_INSERT_REPLACE = 'insertReplace'

export const CHATROOM_INPUT_INITIAL_VALUES = {
  [CHATROOM_INPUT_FIELD_NAME_MESSAGE]: EMPTY_STRING,
  [CHATROOM_INPUT_FIELD_NAME_TEMPLATE]: null,
}

export const CHATROOM_INPUT_INSERT_REPLACE_OPTION_VALUE = {
  Insert: 'Insert',
  Replace: 'Replace',
}

export const CHATROOM_INPUT_TEMPLATE_CONFIRMATION_INITIAL_VALUES = {
  [CHATROOM_INPUT_FIELD_NAME_INSERT_REPLACE]:
    CHATROOM_INPUT_INSERT_REPLACE_OPTION_VALUE.Insert,
}

export const CHATROOM_INPUT_WYSIWYG_MIN_HEIGHT = 120

export const CHATROOM_INPUT_WYSIWYG_MAX_HEIGHT_OFFSET_PX = 240

export const CHATROOM_INPUT_WYSIWYG_FULL_SCREEN_MAX_HEIGHT_VH_FRACTION = 0.5

export const CHATROOM_INPUT_WYSIWYG_FULL_SCREEN_MAX_HEIGHT_OFFSET_PX = 120

export const CHATROOM_INPUT_TEMPLATES_API_PARAMS = {
  hidden: false,
  ordering: 'name',
  page_size: 10,
  tag: 'request_comment',
}

export const CHATROOM_INPUT_NOTIFICATION_AI_DRAFT_NOT_APPLIED =
  'chatroomInputAiDraftNotApplied'

export const CHATROOM_MESSAGE_ACTION_CREATE_REQUEST = 'createRequest'

export const CHATROOM_MESSAGE_ACTION_ATTACH_REQUEST = 'attachRequest'

export const CHATROOM_MESSAGE_ACTION_DELETE = 'delete'

export const CHATROOM_MESSAGE_ACTION_EDIT = 'edit'

export const CHATROOM_MESSAGE_FILES_VISIBLE_COUNT = 3

export const QA_NAME_CHATROOM_MESSAGE_AUTHOR = 'chatroomMessageAuthor'

export const QA_NAME_CHATROOM_MESSAGE_LIKE = 'chatroomMessageLike'

export const QA_NAME_CHATROOM_MESSAGE_ACTIONS = 'chatroomMessageActions'

export const QA_NAME_CHATROOM_MESSAGE_TYPE_MODAL = 'chatroomMessageTypeModal'

export const QA_NAME_CHATROOM_MESSAGE_EDITED = 'chatroomMessageEdited'

export const QA_NAME_CHATROOM_MESSAGE_EDIT_SAVE = 'chatroomMessageEditSave'

export const QA_NAME_CHATROOM_MESSAGE_EDIT_CANCEL = 'chatroomMessageEditCancel'

export const CHATROOM_MESSAGE_FIELD_NAME_TYPE = 'type'

export const CHATROOM_TYPE = {
  Private: 'private',
  Public: 'public',
}
